import { useNavigate } from "react-router";
import { useCallback } from "react";
import { InvoiceMoneyTransferScreenPath } from "./InvoiceMoneyTransferScreen.tsx";

export function useToMoneyTransferWithInvoice() {
  const navigate = useNavigate();

  const toMoneyTransferWithInvoice = useCallback(
    ({ productId, priceId }: { productId: string; priceId: string }) => {
      navigate(
        `${InvoiceMoneyTransferScreenPath}?productId=${productId}&priceId=${priceId}`,
      );
    },
    [navigate],
  );

  return {
    toMoneyTransferWithInvoice,
  };
}
